import { render } from "./HealthDashboardScreen.vue?vue&type=template&id=1db54e3a"
import script from "./HealthDashboardScreen.vue?vue&type=script&lang=js"
export * from "./HealthDashboardScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__